<template>
	<v-dialog v-model="openD" max-width="700" persistent>
		<v-card>
			<v-card-title class="headline">
				<span v-html="!result.id ? 'Nuevo usuario' : 'Edición de usuario'"></span>
			</v-card-title>
			<v-card-text>
				<v-text-field
						label="Nombre"
						v-model="result.name"
						name="Nombre"
						v-validate="'required'"
						:error-messages="errors.collect('Nombre')"
				></v-text-field>
				<v-text-field
						label="Identificación"
						v-model="result.username"
						name="Identificacion"
						v-validate="'required'"
						:error-messages="errors.collect('Identificacion')"
				></v-text-field>
				<v-text-field
						label="Correo electrónico"
						v-model="result.email"
						name="Correo electrónico"
						v-validate="'required|email'"
						:error-messages="errors.collect('Correo electrónico')"
				></v-text-field>
				<v-text-field
                        v-if="!result.id"
                        key="password"
						label="Contraseña"
						v-model="result.password"
						:append-icon="showPassword ? 'mdi mdi-eye' : 'mdi mdi-eye-off'"
						:type="showPassword ? 'text' : 'password'"
						name="Contraseña"
						v-validate="'required'"
						:error-messages="errors.collect('Contraseña')"
						@click:append="showPassword = !showPassword"
				></v-text-field>
				<v-select
						label="Rol"
						v-model="result.roles"
						:items="roles"
						item-value="id"
						item-text="name"
						multiple
						return-object
				></v-select>
				<v-select
						v-if="result.role_id && result.role_id !== 1"
						key="selectSede"
						label="Sede"
						v-model="result.sede_id"
						:items="sedes"
						item-value="id"
						item-text="nombre"
						name="Sede"
						v-validate="'required'"
						:error-messages="errors.collect('Sede')"
				>
					<template slot="selection" slot-scope="data">
						<div style="width: 100% !important;" v-if="sedes">
							<v-list-tile>
								<v-list-tile-content>
									<v-list-tile-title>{{ data.item.CodSedeProv }} - {{ data.item.nombre }}</v-list-tile-title>
									<v-list-tile-sub-title class=caption>{{ data.item.telefono ? data.item.telefono + ' - ' : '' }}{{ data.item.direccion }}</v-list-tile-sub-title>
								</v-list-tile-content>
							</v-list-tile>
						</div>
					</template>
					<template slot="item" slot-scope="data">
						<div style="width: 100% !important;" v-if="sedes">
							<v-list-tile>
								<v-list-tile-content>
									<v-list-tile-title>{{ data.item.CodSedeProv }} - {{ data.item.nombre }}</v-list-tile-title>
									<v-list-tile-sub-title class=caption>{{ data.item.telefono ? data.item.telefono + ' - ' : '' }}{{ data.item.direccion }}</v-list-tile-sub-title>
								</v-list-tile-content>
							</v-list-tile>
						</div>
					</template>
				</v-select>
			</v-card-text>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn
						@click="close"
						:disabled="load"
				>
					Cancelar
				</v-btn>
				<v-btn
						color="primary"
						:loading="load"
						:disabled="load"
						@click="submit"
				>
					Registrar
				</v-btn>
			</v-card-actions>
		</v-card>
		<app-section-loader :status="loader"></app-section-loader>
	</v-dialog>
</template>

<script>
export default {
    data: () => ({
        openD: false,
        showPassword: false,
        load: false,
        loader: false,
		roles: [],
		usuario: null,
        result: {
            id: null,
            username: null,
            email: null,
            password: null,
            role_id: null,
            name: null,
            sede_id: null
        }
	}),
	watch: {
        'result.role_id' (val) {
            if (val && val === 1) this.result.sede_id = null
		}
	},
	computed: {
        sedes() {
            return this.$store.state.general.sedes
        }
	},
	created () {
      this.getRoles()
	},
	methods: {
  	    submit () {
            this.$validator.validateAll().then(result => {
                if (result) {
                    this.loading()
					let request = this.result.id ? this.axios.put(`users/${this.result.id}`, this.result) : this.axios.post(`users`, this.result)
                    request
                        .then((response) => {
                            this.$emit('onSuccess', response.data)
                            this.$store.commit('snackbar', {color: 'success', message: `El usuario se ha creado correctamente`})
                            this.close()
                        }).catch(e => {
                        this.loading(false)
                        this.$store.commit('snackbar', {color: 'error', message: `al registrar la información del usuario`, error: e})
                    })
				}
            })
		},
        getRoles () {
            this.axios.get(`roles`)
                .then(response => {
					this.roles = response.data
                }).catch(e => {
                this.$store.commit('snackbar', {color: 'error', message: `al traer los roles disponibles.`, error: e})
                this.close()
            })
        },
        getUser (id) {
            this.loading()
			this.loader = true
            this.axios.get(`users/${id}`)
                .then(response => {
                    response.data.role_id = (response.data.roles && response.data.roles.length) ? response.data.roles[0].id : null
                    response.data.sede_id = response.data.sede ? response.data.sede.id : null
                    this.result = response.data
                    this.loading(false)
					setTimeout(()=>{
						this.loader = false
					},300)
                }).catch(e => {
                this.loading(false)
				this.loader = false
                this.$store.commit('snackbar', {color: 'error', message: `al traer los datos del usuario.`, error: e})
                this.close()
            })
        },
		open (id) {
  	        id && (this.getUser(id))
		  this.openD = true
		},
		loading (val = true) {
		  this.load = val
		},
		close () {
		  	this.openD = false
            setTimeout(() => {
                this.load = false
                this.loader = false
                this.result.id = null
                this.result.username = null
                this.result.email = null
                this.result.password = null
                this.result.role_id = null
                this.result.name = null
                this.result.sede_id = null
                this.result.roles = []
                this.$validator.reset()
            }, 300)
		}
  	}
}
</script>

